import apiInfraction from "../axios/apiInfraction";

class FileService {
  static async saveFileUrl(url, groupCode) {
    try {
      const body = { url, groupCode };

      const response = await apiInfraction.post(`/files/create`, body);
      if (response.status < 300) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error fetching faults:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }
}

export default FileService;
